import { createContext } from 'react';

/**
 * @typedef {'light' | 'dark' | 'system'} ThemePreference
 * @typedef {'light' | 'dark'} ResolvedTheme
 */

const ThemeContext = createContext({
  /** User's stored preference. `'system'` follows OS `prefers-color-scheme`. */
  theme: 'system',
  /** Actually applied theme — always `'light'` or `'dark'`. */
  resolvedTheme: 'light',
  /** @type {(next: ThemePreference) => void} */
  setTheme: () => {},
  /** Cycles light → dark → system → light. */
  toggleTheme: () => {},
});

export default ThemeContext;
